'use client';

import { sendCommerceEvent } from '@/components/newRelic';
import { showToast } from '@/redux/navigationSlice';
import { pushUserdata } from '@/redux/userdataSlice';
import { type commerceJWT, login, loginParams, type loginResponse } from '@repo/ecommerce-api';
import { Login } from '@repo/ui';
import { deleteClientCookie, parseJwt, setClientCookie } from '@repo/utils';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default function Page(): React.JSX.Element {
  const router = useRouter();
  const dispatch = useDispatch();
  const forceMock = process.env.NEXT_PUBLIC_ECOMMERCE_API_FORCEMOCK === 'true';
  const mockExpire = new Date(Date.now() + 12 * 60 * 60 * 1000).toUTCString();
  useEffect(() => {
    deleteClientCookie(['role-commerce', 'token-commerce', 'userId-commerce']);
  }, []);

  return (
    <Login<loginResponse, loginParams>
      credentialType="username"
      connector={login}
      callback={(response) => {
        const decodedToken = parseJwt(response.token) as commerceJWT;
        const expireDate = forceMock ? mockExpire : new Date(decodedToken?.exp * 1000).toUTCString();
        setClientCookie('token-commerce', response.token, expireDate);
        setClientCookie('role-commerce', decodedToken.role);
        dispatch(
          pushUserdata({
            isAuth: true,
            username: decodedToken?.sub,
            role: decodedToken?.role,
            ecommerce: decodedToken?.ecommerce,
            comercionombre: decodedToken?.comercionombre,
          }),
        );
        sendCommerceEvent({
          type: 'interaction',
          subtype: 'login',
          data: {
            page: 'login',
            username: decodedToken?.sub,
            role: decodedToken?.role,
            ecommerce: decodedToken?.ecommerce,
            comercionombre: decodedToken?.comercionombre,
          },
        });
        if (decodedToken.role === 'ADMIN') {
          router.push('/orders');
        } else {
          router.push('/new_order');
        }
      }}
      onError={() => dispatch(showToast({ kind: 'error', text: 'Usuario y/o contraseña incorrectos' }))}
    />
  );
}
